export default __webpack_public_path__ + "static/media/lightbulb.3b7ea364.svg";